import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IWizStep } from '~/app/open-age/core/structures/wiz/wiz-step.interface';

@Component({
  selector: 'drive-file-list-uploader',
  templateUrl: './file-list-uploader.component.html',
  styleUrls: ['./file-list-uploader.component.css']
})
export class FileListUploaderComponent implements OnInit, IWizStep {
  code: string;
  title: string;
  isSelected: boolean;
  isOpen: boolean;
  isComplete: boolean;
  required: boolean;
  hasError: boolean;
  isDisabled: boolean;
  icon: string;

  constructor() { }

  ngOnInit() {
  }

  validate(): boolean {
    return true;
  }
  complete(): boolean | Observable<any> {
    return true;
  }
}
